import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InitialContactDialogData } from './initial-contact-dialog.model';
import { UIControlService } from 'src/app/shared/uicontrol.service';
import { ContactService } from '../contact.service';
import { ContactMessageForm } from '../contact-message.form';

@Component({
  selector: 'app-initial-contact-dialog',
  templateUrl: './initial-contact-dialog.component.html',
  styleUrls: ['./initial-contact-dialog.component.scss']
})
export class InitialContactDialogComponent implements OnInit {
  sending = false;
  formModel: ContactMessageForm;
  constructor(
    public dialogRef: MatDialogRef<InitialContactDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InitialContactDialogData,
    private uiService: UIControlService,
    private contactService: ContactService
  ) {}

  ngOnInit(): void {
    this.formModel = new ContactMessageForm(
      this.data.serviceDocumentKey,
      this.data.clientUserKey
    );
  }

  send() {
    if (this.formModel.formGroup.valid) {
      this.sending = true;
      this.contactService.initialiseContact(this.formModel.model).subscribe(
        () => {
          this.uiService.notifySuccess('Contact created.');
          this.dialogRef.close(true);
        },
        error => {
          console.error(error);
          this.uiService.notifyFailure(
            'Something went wrong. Please try again in a few minutes'
          );
        },
        () => (this.sending = false)
      );
    } else {
      this.uiService.notifyFailure('Please correct your entered message.');
    }
  }
}
